import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Root.css';
import '../styles/Header.css';
import '../styles/Footer.css';

const RegistrationSuccess = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Confirmation de votre adhésion en cours...');

  const API_BASE_URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost'
    : 'https://museedestroupesdemarine.fr';

  useEffect(() => {
    async function verifyRegistration() {
      try {
        // Récupérer l'ID du paiement et customer_id depuis localStorage ou les paramètres URL
        const urlParams = new URLSearchParams(window.location.search);
        const payment_id = localStorage.getItem('current_payment_id');
        const customer_id = urlParams.get('id') || localStorage.getItem('current_customer_id');

        if (!payment_id || !customer_id) {
          setStatus('error');
          setMessage('Informations de paiement manquantes.');
          return;
        }

        // Appeler l'API pour vérifier le paiement et envoyer les emails
        const response = await fetch(`${API_BASE_URL}/api/deveniradherent.php?endpoint=registration-success&payment_id=${payment_id}&customer_id=${customer_id}`);

        if (!response.ok) {
          throw new Error('Erreur lors de la confirmation de l\'adhésion');
        }

        const result = await response.json();

        if (result.success) {
          setStatus('success');
          setMessage('');

          // Nettoyer les données du localStorage
          localStorage.removeItem('current_payment_id');
          localStorage.removeItem('current_customer_id');
        } else {
          setStatus('error');
          setMessage(`Erreur de confirmation: ${result.reason || 'Raison inconnue'}`);
        }
      } catch (error) {
        console.error('Error verifying registration:', error);
        setStatus('error');
        setMessage('Une erreur est survenue lors de la confirmation.');
      }
    }

    verifyRegistration();
  }, [API_BASE_URL]);

  return (
    <div>
      <div className="success-container">
        <div className="success-icon">
          <i className={status === 'loading' ? 'fas fa-spinner fa-spin' :
                     status === 'success' ? 'fas fa-check-circle' :
                     'fas fa-exclamation-circle'}></i>
        </div>
        <h1>{status === 'success' ? 'Adhésion réussie !' : 'Traitement en cours...'}</h1>
        <p>{message}</p>
        {status === 'success' && (
          <>
            <p>Un email de confirmation a été envoyé à votre adresse.</p>
            <p>Nous vous remercions pour votre adhésion et votre soutien. Vous recevrez votre numéro d'adhérent prochainement.</p>
          </>
        )}
        <Link to="/" className="return-btn">Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
